export function interpolateTemplate(
  template: string,
  recordData: Record<string, unknown>,
  systemFields: Record<string, unknown>,
  hiddenFieldNames: Set<string>
): string {
  return template.replace(/\{\{(\w+)\}\}/g, (match, fieldName: string) => {
    if (hiddenFieldNames.has(fieldName)) return ''
    const value = recordData[fieldName] ?? systemFields[fieldName]
    if (value === undefined || value === null) return match
    if (Array.isArray(value)) return value.join(', ')
    return String(value)
  })
}

export function extractTemplateFields(template: string): string[] {
  const fields: string[] = []
  const regex = /\{\{(\w+)\}\}/g
  let match: RegExpExecArray | null
  while ((match = regex.exec(template)) !== null) {
    if (!fields.includes(match[1])) fields.push(match[1])
  }
  return fields
}
